import {SODeleteRelationshipAttribute} from '../../core/relationship-attribute/so-delete-relationship-attribute';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRelationshipAttribute extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRelationshipAttribute;
}